import { render, staticRenderFns } from "./QuestionTypeOrder.vue?vue&type=template&id=3ecad890"
import script from "./QuestionTypeOrder.vue?vue&type=script&lang=js"
export * from "./QuestionTypeOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports